export default {
	props: {
		hasFocus: {
			type: Boolean,
			default: false
		}
	},
	directives: {
		focus: {
			inserted: function(el, binding) {
				if (binding.value) {
					el.focus();
				}
			}
		}
	}
};
